import moment from 'moment'

let formatDate = time =>{
    if (time == '' || !time){
        return '——'
    }else{
        var date = moment(time).format('MM.DD');
        return date;                        
    }
}

let momentDate = time =>{
    if (time == '' || !time){
        return '——'
    }else{
        var date = moment(time).format('YYYY-MM-DD HH:mm');
        return date;                        
    }
}

let removeHtml = input => {
    return input && input.replace(/<(?:.|)*?>/gm, '')
    .replace(/(&rdquo;)/g, '"')
    .replace(/&ldquo;/g, '"')
    .replace(/&mdash;/g, '-')
    .replace(/&nbsp;/g, '')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&bull;/g, '•')
    .replace(/&middot;/g, '•')
    .replace(/<[ws"':=/]*/, '');
}

let removeStyle = input => {
    return input && input.replace(/style\s*?=\s*?(['"])[\s\S]*?\1/, '')
}

let toFixed2 = val => {
    console.log(val)
    return val && Number(val).toFixed(2)
}

export{formatDate, momentDate, removeHtml, removeStyle, toFixed2}


// WEBPACK FOOTER //
// ./src/filter/index.js